import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateShareDto } from '../dtos/createShare.dto';
import { GetShareDto } from '../dtos/getShare.dto';
import { ShareInformationDTO } from '../dtos/shareInformation.dto';
import { ShareResponseDto } from '../dtos/shareResponse.dto';

export const shareAnnualReport = createActionGroup({
    source: '[Aumico-AnnualReport-Shares] Share Annual Report',
    events: {
        do: props<{
            payload: CreateShareDto;
        }>(),
        success: props<{ payload: ShareResponseDto }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});
export const getNewAnnualReportsSharedWithMe = createActionGroup({
    source: '[Aumico-AnnualReport-Shares] New Annual Reports Shared With Me',
    events: {
        do: emptyProps(),
        success: props<{ payload: GetShareDto[] }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});
export const declineSharedAnnualReport = createActionGroup({
    source: '[Aumico-AnnualReport-Shares] decline AnnualReport Shared With Me',
    events: {
        do: props<{
            payload: string;
        }>(),
        success: emptyProps(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const acceptSharedAnnualReport = createActionGroup({
    source: '[Aumico-AnnualReport-Shares] accept AnnualReport Shared With Me',
    events: {
        do: props<{
            payload: string;
        }>(),
        success: emptyProps(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const getShareInformation = createActionGroup({
    source: '[Aumico-AnnualReport-Shares] getShareInformation',
    events: {
        do: props<{
            payload: string;
        }>(),
        success: props<{
            payload: {
                shareInformation: ShareInformationDTO;
                annualReportMetaInformationId: string;
            };
        }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});
